import { IFormTemplateActions, FormTemplateContext } from './actions.types';
import {
  IFormFieldData,
  IFormFieldOptionTodoData,
  IFormFieldOptionTodoTemplateData,
  IFormTemplateData
} from '@/models';
import {
  IFetchFormFieldParams,
  IFetchFormTemplatesParams,
  IFormFieldOptionTodosPayload,
  IUpdateFormTemplateStatePayload
} from '@/services';

export const actions: IFormTemplateActions = {
  fetchFormTemplates(
    context: FormTemplateContext,
    params?: IFetchFormTemplatesParams
  ): Promise<void> {
    return this.$services.formTemplate
      .fetchFormTemplates(params)
      .then((formTemplates: IFormTemplateData[]) => {
        context.commit('SET_FORM_TEMPLATES', formTemplates);
      });
  },

  fetchFormTemplate(
    context: FormTemplateContext,
    payload: number
  ): Promise<void> {
    return this.$services.formTemplate
      .fetchFormTemplate(payload)
      .then((formTemplate: IFormTemplateData) => {
        const index = context.state.formTemplates.findIndex(
          (v: IFormTemplateData) => v.id === formTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_TEMPLATE', formTemplate);
        } else {
          context.commit('UPDATE_FORM_TEMPLATE', formTemplate);
        }
      });
  },

  createFormTemplate(
    context: FormTemplateContext,
    payload: IFormTemplateData
  ): Promise<IFormTemplateData> {
    return this.$services.formTemplate
      .createFormTemplate(payload)
      .then((formTemplate: IFormTemplateData) => {
        context.commit('ADD_FORM_TEMPLATE', formTemplate);
        return formTemplate;
      });
  },

  updateFormTemplate(
    context: FormTemplateContext,
    payload: IFormTemplateData
  ): Promise<void> {
    return this.$services.formTemplate
      .updateFormTemplate(payload)
      .then((formTemplate: IFormTemplateData) => {
        const index = context.state.formTemplates.findIndex(
          (v: IFormTemplateData) => v.id === formTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_TEMPLATE', formTemplate);
        } else {
          context.commit('UPDATE_FORM_TEMPLATE', formTemplate);
        }
      });
  },

  deleteFormTemplate(
    context: FormTemplateContext,
    payload: number
  ): Promise<void> {
    return this.$services.formTemplate.deleteFormTemplate(payload).then(() => {
      context.commit('REMOVE_FORM_TEMPLATE', payload);
    });
  },

  updateFormTemplateState(
    context: FormTemplateContext,
    payload: IUpdateFormTemplateStatePayload
  ): Promise<void> {
    return this.$services.formTemplate
      .updateFormTemplateState(payload)
      .then((formTemplate: IFormTemplateData) => {
        const index = context.state.formTemplates.findIndex(
          (v: IFormTemplateData) => v.id === formTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_TEMPLATE', formTemplate);
        } else {
          context.commit('UPDATE_FORM_TEMPLATE', formTemplate);
        }
      });
  },

  //fields
  fetchFormFields(
    context: FormTemplateContext,
    params: IFetchFormFieldParams
  ): Promise<void> {
    return this.$services.formTemplate
      .fetchFormFields(params)
      .then((formFields: IFormFieldData[]) => {
        context.commit('SET_FORM_FIELDS', formFields);
      });
  },

  fetchFormField(context: FormTemplateContext, payload: number): Promise<void> {
    return this.$services.formTemplate
      .fetchFormField(payload)
      .then((formField: IFormFieldData) => {
        const index = context.state.formFields.findIndex(
          (v: IFormFieldData) => v.id === formField.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_FIELD', formField);
        } else {
          context.commit('UPDATE_FORM_FIELD', formField);
        }
      });
  },

  createFormField(
    context: FormTemplateContext,
    payload: IFormFieldData
  ): Promise<IFormFieldData> {
    return this.$services.formTemplate
      .createFormField(payload)
      .then((formField: IFormFieldData) => {
        context.commit('ADD_FORM_FIELD', formField);
        return formField;
      });
  },

  updateFormField(
    context: FormTemplateContext,
    payload: IFormFieldData
  ): Promise<void> {
    return this.$services.formTemplate
      .updateFormField(payload)
      .then((formField: IFormFieldData) => {
        const index = context.state.formFields.findIndex(
          (v: IFormFieldData) => v.id === formField.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_FIELD', formField);
        } else {
          context.commit('UPDATE_FORM_FIELD', formField);
        }
      });
  },

  deleteFormField(
    context: FormTemplateContext,
    payload: number
  ): Promise<void> {
    return this.$services.formTemplate.deleteFormField(payload).then(() => {
      context.commit('REMOVE_FORM_FIELD', payload);
    });
  },

  //todos
  fetchFormFieldOptionTodos(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodosPayload
  ): Promise<void> {
    return this.$services.formTemplate
      .fetchFormFieldOptionTodos(payload.params!)
      .then((formFields: IFormFieldOptionTodoData[]) => {
        context.commit('SET_FORM_FIELD_OPTION_TODOS', formFields);
      });
  },

  createFormFieldOptionTodo(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodosPayload
  ): Promise<void> {
    return this.$services.formTemplate
      .createFormFieldOptionTodo(payload.params!, payload.data!)
      .then((formField: IFormFieldOptionTodoData) =>
        context.commit('ADD_FORM_FIELD_OPTION_TODO', formField)
      );
  },

  updateFormFieldOptionTodo(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodosPayload
  ): Promise<void> {
    return this.$services.formTemplate
      .updateFormFieldOptionTodo(payload.params!, payload.data!)
      .then((formField: IFormFieldOptionTodoData) => {
        const index = context.state.formFieldOptionTodos.findIndex(
          (v: IFormFieldOptionTodoData) => v.id === formField.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_FIELD_OPTION_TODO', formField);
        } else {
          context.commit('UPDATE_FORM_FIELD_OPTION_TODO', formField);
        }
      });
  },

  deleteFormFieldOptionTodo(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodosPayload
  ): Promise<void> {
    return this.$services.formTemplate
      .deleteFormFieldOptionTodo(payload.params!, payload.id!)
      .then(() => {
        context.commit('REMOVE_FORM_FIELD_OPTION_TODO', payload);
      });
  },

  //todo template
  fetchFormTodoTemplates(context: FormTemplateContext): Promise<void> {
    return this.$services.formTemplate
      .fetchFormTodoTemplates()
      .then((formTodoTemplates: IFormFieldOptionTodoTemplateData[]) => {
        context.commit('SET_FORM_TODO_TEMPLATES', formTodoTemplates);
      });
  },

  fetchFormTodoTemplate(
    context: FormTemplateContext,
    payload: number
  ): Promise<void> {
    return this.$services.formTemplate
      .fetchFormTodoTemplate(payload)
      .then((formTodoTemplate: IFormFieldOptionTodoTemplateData) => {
        const index = context.state.formTodoTempates.findIndex(
          (v: IFormFieldOptionTodoTemplateData) => v.id === formTodoTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_TODO_TEMPLATE', formTodoTemplate);
        } else {
          context.commit('UPDATE_FORM_TODO_TEMPLATE', formTodoTemplate);
        }
      });
  },

  createFormTodoTemplate(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodoTemplateData
  ): Promise<IFormFieldOptionTodoTemplateData> {
    return this.$services.formTemplate
      .createFormTodoTemplate(payload)
      .then((formTodoTemplate: IFormFieldOptionTodoTemplateData) => {
        context.commit('ADD_FORM_TODO_TEMPLATE', formTodoTemplate);
        return formTodoTemplate;
      });
  },

  updateFormTodoTemplate(
    context: FormTemplateContext,
    payload: IFormFieldOptionTodoTemplateData
  ): Promise<void> {
    return this.$services.formTemplate
      .updateFormTodoTemplate(payload)
      .then((formTemplate: IFormFieldOptionTodoTemplateData) => {
        const index = context.state.formTodoTempates.findIndex(
          (v: IFormFieldOptionTodoTemplateData) => v.id === formTemplate.id
        );
        if (index === -1) {
          context.commit('ADD_FORM_TODO_TEMPLATE', formTemplate);
        } else {
          context.commit('UPDATE_FORM_TODO_TEMPLATE', formTemplate);
        }
      });
  },

  deleteFormTodoTemplate(
    context: FormTemplateContext,
    payload: number
  ): Promise<void> {
    return this.$services.formTemplate
      .deleteFormTodoTemplate(payload)
      .then(() => {
        context.commit('REMOVE_FORM_TODO_TEMPLATE', payload);
      });
  }
};
